import React from "react";

import { container, header, content } from "./generator-layout.module.scss";

import MainLayout from "./main-layout";
import HeaderSurvey from "../components/organisms/headers/headerSurvey";

interface IGeneratorLayoutProps {
    className?: string;
}

const GeneratorLayout: React.FC<IGeneratorLayoutProps> = ({ children }) => {
    return (
        <MainLayout
            containerClassName={container}
            HeaderComponent={<HeaderSurvey className={header} />}
            hasPaddingTop={true}
        >
            <div className={content}>{children}</div>
        </MainLayout>
    );
};

export default GeneratorLayout;
